@if (itemBeneficiare?.id) {
  <div class="ldh-container">

    <!-- Table -->
    <div class="ldh-table-wrap">
      <table class="ldh-table">
        <thead>
          <tr>
            <th class="col-num">
              # <i class="fa fa-redo ldh-refresh" (click)="getItemsDemandeHospitalisationActive()" title="Actualiser"></i>
            </th>
            <th>N° demande</th>
            <th>Raison</th>
            <th>Date</th>
            @if (type_hospitalisation === 'HM') {
              <th title="Jours demandés">J. dem.</th>
              <th title="Jours accordés">J. acc.</th>
              <th>Entrée</th>
              <th>Sortie</th>
              <th>Chambre</th>
            }
            @if (type_hospitalisation === 'HC') {
              <th>Date interv.</th>
            }
            @if (type_hospitalisation === 'MEO') {
              <th>H. début</th>
              <th>H. fin</th>
            }
            <th>Statut</th>
            <th class="col-actions"></th>
          </tr>
        </thead>
        <tbody>
          @for (item of itemsDemandeHospitalisation; track item.id; let i = $index) {
            <tr [class.row-active]="item.is_active" (click)="onSelectRow(item)">

              <td class="col-num">{{ i + 1 }}</td>
              <td class="col-code">{{ item.codification }}</td>
              <td>{{ item.raison_hospitalisation_libelle }}</td>
              <td class="col-date">{{ item.created_at | date:'dd/MM/yyyy HH:mm' }}</td>

              @if (type_hospitalisation === 'HM') {
                <td class="text-center">{{ item.duree_demande }}</td>
                <td class="text-center">{{ item.duree_accord || '—' }}</td>
                <td class="col-date">{{ item.date_entree ? (item.date_entree | date:'dd/MM/yyyy') : '—' }}</td>
                <td class="col-date">{{ item.date_sortie ? (item.date_sortie | date:'dd/MM/yyyy') : '—' }}</td>
                <td>{{ item.type_chambre_hospitalisation_libelle }}</td>
              }
              @if (type_hospitalisation === 'HC') {
                <td class="col-date">{{ item.date_intervention ? (item.date_intervention | date:'dd/MM/yyyy') : '—' }}</td>
              }
              @if (type_hospitalisation === 'MEO') {
                <td>{{ item.heure_debut_observation }}</td>
                <td>{{ item.heure_fin_observation }}</td>
              }

              <!-- Statut badge -->
              <td>
                @if (item.is_rejected) {
                  <span class="ldh-badge rejected"><i class="fa fa-times-circle"></i> Rejeté</span>
                } @else if (item.is_validated) {
                  <span class="ldh-badge validated"><i class="fa fa-check-circle"></i> Validé</span>
                } @else {
                  <span class="ldh-badge pending"><i class="fa fa-clock"></i> En attente</span>
                }
              </td>

              <!-- Actions -->
              <td class="col-actions" (click)="$event.stopPropagation()">
                @if (item.is_rejected) {
                  <button class="ldh-btn danger" (click)="showRefusMessage(item)" title="Voir motif de rejet">
                    <i class="fa fa-info-circle"></i>
                  </button>
                }
                @if (!item.is_clotured && !item.is_sortie && !item.is_rejected && item.is_traite) {
                  <button class="ldh-btn warning" (click)="confirmSaveItem(item)" title="Clôturer / Sortie">
                    <i class="fa fa-door-open"></i>
                  </button>
                }
                @if (item.is_expiered && (type_hospitalisation === 'HM' || type_hospitalisation === 'HC')) {
                  <button class="ldh-btn info" (click)="confirmDemandeProlongation(item)" title="Prolonger">
                    <i class="fa fa-calendar-plus"></i>
                  </button>
                }
              </td>

            </tr>
          } @empty {
            <tr>
              <td colspan="14" class="ldh-empty">
                <div class="ldh-empty-inner">
                  <i class="fa fa-folder-open"></i>
                  <span>Aucune demande trouvée</span>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Exploitation form -->
    @if (selectedDemande && selectedDemande.id) {
      <app-form-exploitation-hospit
        (onUpdateParent)="onUpdateParent($event)"
        [selectedDemandeHospitalisation]="selectedDemande"
        [itemBeneficiare]="itemBeneficiare">
      </app-form-exploitation-hospit>
    }

  </div>
}
